// eslint-disable-next-line import/prefer-default-export
export const WAIT_BETWEEN_REQUESTS_IN_SERIES = 100
